export default __webpack_public_path__ + "static/media/Logo.a8528990.png";